import { css } from '@emotion/core';

import { Animation, Colors } from '@zapier/design-system';

export const focusCss = css`
  transition-property: all;
  transition-timing-function: ${Animation.transitionTimingFunction};
  transition-duration: ${Animation.transitionDuration};
  cursor: pointer;
  border-radius: 5px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    border: 3px solid transparent;
    border-radius: 14px;
    transition-property: all;
    transition-timing-function: ${Animation.transitionTimingFunction};
    transition-duration: ${Animation.transitionDuration};
  }
  &:focus {
    border-radius: 10px;
    &::before {
      border-color: ${Colors.ocean};
      top: -6px;
      right: -6px;
      bottom: -6px;
      left: -6px;
    }
  }
`;

export const rebrandFocusCss = css`
  transition-property: all;
  transition-timing-function: ${Animation.transitionTimingFunction};
  transition-duration: ${Animation.transitionDuration};
  cursor: pointer;
  border-radius: 5px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    border: 3px solid transparent;
    border-radius: 9px;
    transition-property: all;
    transition-timing-function: ${Animation.transitionTimingFunction};
    transition-duration: ${Animation.transitionDuration};
  }
  &:focus {
    border-radius: 5px;
    &::before {
      border-color: ${Colors.blue};
      top: -6px;
      right: -6px;
      bottom: -6px;
      left: -6px;
    }
  }
`;
